/**
 * CAROUSEL BLOCK
 *
 * This appears in a matrix block of a Page Builder field. See "Carousel Block" in
 * ./templates/styleguide/_builders/page-builder/carousel.html
 *
 * @returns {Promise<void>}
 */
const main = async () => {
    const [
        {default: Vue},
        {CarouselPlugin},
    ] = await Promise.all([
        import(/* webpackChunkName: "vue" */ 'vue'),
        import(/* webpackChunkName: "bs-carousel" */ 'bootstrap-vue'),
    ]);

    Vue.use(CarouselPlugin);

    const vm = new Vue({
        name: 'CarouselMatrixBlock',
        el: '#carousel-block',
        delimiters: ['[[', ']]'],
    });

    return vm;
};

// Execute async function
main().then((vm) => {
});